import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import ClearTicket from './clearTicket';
import TicketNumberCount from './ticketNumberCount';
import LastTicket from './lastTicket';
import TicketCount from './ticketCount';
import { TicketsCount } from '../../../../core/constants/gameConstants';

export const TicketsBlock = observer(() => {
  return (
    <div className='keno-bet-tickets'>
      <div className='keno-tickets-row'>
        <ClearTicket />
        <TicketNumberCount />
        {isMobile() ? null : <LastTicket />}
      </div>
      <div className='keno-tickets-row'>
        {TicketsCount.map((el) => {
          return <TicketCount ticketsCount={el} key={el} />;
        })}
        {isMobile() ? <LastTicket /> : null}
      </div>
    </div>
  );
});
